import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// ?safe&mock-data&utm_source=FB&country=DE&area=activity-female-tai-chi-walking-v2&exp=web_female_tai_chi_walking_v2_de~1&lang=de
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-de',
				locale: ['en'],
			},
		},
	},
]

export default config
